import React from 'react';

// Labeled form fields for admin2 modals/forms, matching the fact-find
// TextField conventions (label, required marker, hint, purple focus ring).
const INPUT_CLASSES =
    'w-full rounded-xl border border-[#E5E7EB] bg-white px-3 py-2.5 text-sm text-[#1F2937] placeholder-[#9CA3AF] focus:outline-none focus:ring-2 focus:ring-[#7C5CFC] focus:border-transparent disabled:bg-[#F5F6FA] disabled:text-[#6B7280]';

export const FieldLabel = ({ children, required, htmlFor }) => (
    <label htmlFor={htmlFor} className="block text-sm font-medium text-[#1F2937] mb-2">
        {children}
        {required ? <span className="text-[#DC2626]"> *</span> : null}
    </label>
);

export const TextField = ({ label, required, hint, className = '', ...inputProps }) => (
    <div className={className}>
        {label ? <FieldLabel required={required}>{label}</FieldLabel> : null}
        <input required={required} className={INPUT_CLASSES} {...inputProps} />
        {hint ? <p className="mt-1 text-xs text-[#6B7280]">{hint}</p> : null}
    </div>
);

export const TextAreaField = ({ label, required, hint, className = '', rows = 3, ...textareaProps }) => (
    <div className={className}>
        {label ? <FieldLabel required={required}>{label}</FieldLabel> : null}
        <textarea required={required} rows={rows} className={`${INPUT_CLASSES} resize-y`} {...textareaProps} />
        {hint ? <p className="mt-1 text-xs text-[#6B7280]">{hint}</p> : null}
    </div>
);

export const SelectField = ({ label, required, hint, className = '', children, ...selectProps }) => (
    <div className={className}>
        {label ? <FieldLabel required={required}>{label}</FieldLabel> : null}
        <select required={required} className={INPUT_CLASSES} {...selectProps}>
            {children}
        </select>
        {hint ? <p className="mt-1 text-xs text-[#6B7280]">{hint}</p> : null}
    </div>
);

export const CheckboxField = ({ label, className = '', ...inputProps }) => (
    <label className={`flex items-center gap-3 cursor-pointer select-none ${className}`}>
        <input
            type="checkbox"
            className="h-4 w-4 rounded border-[#D1D5DB] accent-[#7C5CFC] focus:ring-[#7C5CFC]"
            {...inputProps}
        />
        <span className="text-sm text-[#1F2937]">{label}</span>
    </label>
);
